import React, { useState } from "react";
import {
  Typography,
  Box,
  TextField
} from "@mui/material";
import OTP from "../common/otpStep";
import { generateOTP } from "../apiCalls";
import { toast } from "react-toast";

export default function OrderVerification({
  partnerOrderId,
  setPartnerOrderId,
  handlePayment,
  orderId,
  setIsLoading,
}) {
  const [orderIdEntered, setOrderIdEntered] = useState(false);
  const [otpId, setOtpId] = useState("");
  const [attemptsExceeded, setAttemptsExceeded] = useState(false);

  const sentOtp = async () => {
    try {
      setIsLoading(true);
      const response = await generateOTP(orderId, 'payment');
      if (response.success) {
        setOtpId(response.otpId);
        setOrderIdEntered(true);
        setAttemptsExceeded(false);
      } else {
        toast.error("OTP generation failed");
      }
    } catch (err) {
      toast.error("OTP generation failed");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Order Verification
      </Typography>
      {!orderIdEntered || attemptsExceeded ? (
        <>
          <TextField
            fullWidth
            label="Partner Order ID"
            size="small"
            value={partnerOrderId}
            onChange={(e) => setPartnerOrderId(e.target.value)}
          />
          <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
            <button
              className={
                partnerOrderId === ""
                  ? "border-gray-500 bg-gray-500 text-gray-100 border cursor-default rounded-md w-60 p-1 text-sm font-semibold"
                  : "border-blue-600 bg-blue-600 text-gray-100 border cursor-pointer rounded-md w-60 p-1 text-sm font-semibold"
              }
              onClick={sentOtp}
            >
              Submit and Send OTP
            </button>
          </Box>
        </>
      ) : <OTP handleSubmit={handlePayment} otpId={otpId} setAttemptsExceeded={setAttemptsExceeded} setIsLoading={setIsLoading}/>}
    </Box>
  );
}
